

































import { Component, Vue, Ref } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";
import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";

import StudentForm from "@/components/StudentForm/StudentForm.vue";

import { Action } from "vuex-class";
import { IStudentPayload } from "@/models/interfaces/students";
import { AxiosResponse } from "axios";
import { eventCodeByName, EventsNames } from "@/analytics";
import amplitude from "amplitude-js";

interface StudentFormType {
  setLoadingState: (state: boolean) => void;
}

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    StudentForm,
    BasePopup,
    BaseButton
  }
})
export default class StudentsAddView extends Vue {
  @Ref("form")
  private form!: HTMLFormElement & StudentFormType;

  @Action("students/createStudent")
  private createStudent!: (payload: IStudentPayload) => Promise<AxiosResponse>;

  private showValidationPopup = false;
  private popupMessage = "";
  private popupTimeout!: number;

  private creationMessage = "";

  private showPopup(message: string) {
    this.popupMessage = message;
    this.showValidationPopup = true;
  }

  private addStudent(form: IStudentPayload) {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksSaveCreateStudentPage)} ${
          EventsNames.UserClicksSaveCreateStudentPage
        }`
      );

    this.form.setLoadingState(true);

    this.createStudent(form)
      .then(() => {
        this.popupMessage = this.$t("views.students.messages.create") as string;
        this.creationMessage = this.$t(
          "views.students.messages.create"
        ) as string;
        this.showValidationPopup = true;
      })
      .finally(() => {
        this.form.setLoadingState(false);
      });
  }

  private onPopupClose() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(
          EventsNames.UserClicksOkOnPopupAfterStudentCreate
        )} ${EventsNames.UserClicksOkOnPopupAfterStudentCreate}`
      );
    this.showValidationPopup = false;

    if (this.popupMessage === this.creationMessage) {
      this.popupTimeout = window.setTimeout(() => {
        this.$router.push("/students");
      }, 500);
    }
  }

  public beforeDestroy() {
    window.clearTimeout(this.popupTimeout);
  }
}
